export const CART_SAVED_CART_FEATURE = 'cartSavedCart';
export const CART_SAVED_CART_CORE_FEATURE = 'cartSavedCartCore';